import { SendOutlined } from '@ant-design/icons'
import { Upload } from 'antd'
import CropperImage from 'antd-cropper-img'
import { useGate, useUnit } from 'effector-react'

import { $file, Gate, fileAdded } from '../../model/attachment-upload.model'

type UploadAvatarProps = {
  id?: string
  accept?: string
  children: React.ReactNode
}

export function AttachmentInput({
  id,
  accept = 'image/jpeg,image/png',
  children,
}: UploadAvatarProps) {
  const [fileStore, addFile] = useUnit([$file, fileAdded])

  useGate(Gate)

  return (
    <CropperImage
      modalTitle="Отправка изображения"
      aspect={0}
      okText="Отправить"
      okButtonProps={{
        icon: <SendOutlined />,
        iconPosition: 'end',
      }}
    >
      <Upload
        id={id}
        name="avatar"
        accept={accept}
        maxCount={1}
        showUploadList={false}
        fileList={fileStore.file ? [fileStore.file] : []}
        beforeUpload={(file) => {
          addFile(file)
          return false
        }}
      >
        {children}
      </Upload>
    </CropperImage>
  )
}
